module.exports = __webpack_public_path__ + "static/3-0811f1380192044ade4db06d5a6e7e03.jpg";